import {
  DEFAULT_HP_CONTACT_DISTRIBUTOR_ROLE,
  DEFAULT_HP_CONTACT_RESELLER_ROLE,
} from 'legacy/lut/classes/models/partner360/IFormHPContacts'

interface IGetHPContactRoleForEditing {
  isDistributor: boolean
  currentDefaultHpContactRole: string
  currentRole: string | undefined
}
export const getHPContactRoleForEditing = ({
  isDistributor,
  currentDefaultHpContactRole,
  currentRole,
}: IGetHPContactRoleForEditing) => {
  return isDistributor
    ? currentRole == DEFAULT_HP_CONTACT_RESELLER_ROLE
      ? DEFAULT_HP_CONTACT_DISTRIBUTOR_ROLE
      : currentRole || ''
    : currentRole || currentDefaultHpContactRole
}
